// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleSection_root__j8_kI","header":"ToggleSection_header__2dV1E","copy":"ToggleSection_copy__I2ToW","switch":"ToggleSection_switch__01uHP"};